'use client';

import { useEffect } from 'react';

export const ScrollToTop = () => {
  useEffect(() => {
    const mainElement = document.getElementById('main');
    if (mainElement) {
      mainElement.scrollIntoView({ behavior: 'instant', block: 'start' });
    }
  }, []);

  return null;
};
